globalThis.jotaiAtomCache = globalThis.jotaiAtomCache || {
  cache: new Map(),
  get: function get(name, inst) {
    if (this.cache.has(name)) {
      return this.cache.get(name);
    }

    this.cache.set(name, inst);
    return inst;
  }
};
import { useAuth } from '@restworld/feature-authentication';
export function useIsFreemiumUser() {
  var _useAuth = useAuth(),
      user = _useAuth.user;

  return !!(user !== null && user !== void 0 && user.freemium_user);
}